const RenderActiveStep = ({ component }) => (
    component
);

export default RenderActiveStep;